export default __webpack_public_path__ + "static/media/F4.c72b3ae7.gif";